"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _NavList = _interopRequireDefault(require("../lists/NavList"));
var _InlineNavigationModule = _interopRequireDefault(require("./../../scss/navigations/InlineNavigation.module.scss"));
function InlineNavigation(_ref) {
  let {
    links = [],
    classname = '',
    position = 'left'
  } = _ref;
  const contentJustifyMap = new Map([['left', 'flex-start'], ['right', 'flex-end'], ['center', 'center']]);
  return /*#__PURE__*/_react.default.createElement("nav", {
    className: [_InlineNavigationModule.default['inline-navigation'], classname].join(' '),
    style: {
      '--inline-nav-justify-content': contentJustifyMap.get(position)
    }
  }, /*#__PURE__*/_react.default.createElement(_NavList.default, {
    links: links,
    classname: classname
  }));
}
var _default = exports.default = InlineNavigation;